import { render, staticRenderFns } from "./JdsDialog.vue?vue&type=template&id=39ee5923"
import script from "./JdsDialog.vue?vue&type=script&lang=js"
export * from "./JdsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports